import { useMutation } from '@tanstack/react-query';
import { updateCampaignSettings } from './updateCampaignSettings';
import { ErrorResponse, globalErrorResponse } from '../../shared/notification/actions';

export const useUpdateCampaignSettings = () => {
    return useMutation(updateCampaignSettings, {
        onError: (error: ErrorResponse) => globalErrorResponse(error)
    });
};
